module.exports = __webpack_public_path__ + "static/media/pivot_monitor_icon.57c715f2.svg";